export const cargoTypeList = [
  'UNDEFINED',
  'CATEGORY X',
  'CATEGORY Y',
  'CATEGORY Z',
  'CATEGORY OS',
];

export const missingAisDataList = ['SOG', 'ROT', 'COG'];

export const posFixDevList = [
  'UNDEFINED',
  'GPS',
  'GLONASS',
  'COMBINED GPS/GLONASS',
  'LORAN-C',
  'CHAYKA',
  'INTEGRATED NAVIGATION SYSTEM',
  'SURVEYED',
  'GALILEO',
  'INTERNAL',
];

export const typeOfMobile = [
  'CLASS A',
  'CLASS B',
  'SAR AIRBORNE',
  'BASE STATION',
  'ATON',
  'AIRCRAFT',
  'Search and Rescue Transponder',
  'Man Overboard Device',
  'Emergency PIRB',
  'Land Vehicle',
  'Active SART/MOB/EPIRB',
  'Drone Sensor',
];

export const dataSourceTypeList = [
  'AIS',
  'Radar',
  'LRIT',
  'AIS-S',
  'ADS-B',
  'LAND',
  'DRONE_SENSOR',
];
